<template>
  <Slideover :visible="visible">
    <div>
      <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
        <div class="flex items-start justify-between space-x-3">
          <h2 class="text-lg leading-7 font-medium">
            {{ title }}
          </h2>
          <div class="h-7 flex items-center">
            <button
              type="button"
              aria-label="Close panel"
              @click="$emit('toggle-slideover', 'customerEdit')"
              class="text-green-300 hover:text-white transition ease-in-out duration-150"
            >
              <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <div class="relative flex-1 py-3 px-2 mx-4">
        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <label
              for="first_name"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              First name
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="first_name"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customerClone.firstName"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="last_name"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Last name
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="last_name"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customerClone.lastName"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Email address
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="email"
                type="email"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.email"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="phone"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Phone
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="phone"
                type="phone"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.phone"
              />
            </div>
          </div>

          <div class="sm:col-span-6 border-t border-gray-300"></div>

          <div class="sm:col-span-6">
            <label
              for="street_address"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Street address
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="street_address"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.address"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="city"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              City
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="city"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.city"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="state"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              State / Province
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="state"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.state"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="zip"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              ZIP / Postal
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="zip"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="customer.zip"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="button"
            @click="$emit('toggle-slideover', 'customerEdit')"
            class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
          >
            Cancel
          </button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="submit"
            @click="updateCustomer"
            class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out"
          >
            Save
          </button>
        </span>
      </div>
    </div>
  </Slideover>
</template>
<script>
/**
 * TODO
 */
import Slideover from "@/components/layout/Slideover.vue";

export default {
  name: "CustomerEdit",
  data() {
    return {
      customerClone: {}
    };
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    footer: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object
    }
  },
  created() {},
  components: {
    Slideover
  },
  computed: {},
  methods: {
    updateCustomer() {
      console.log(this.customerClone);
    }
  },
  mounted() {
    // (dirty deep clone)
    this.customerClone = JSON.parse(JSON.stringify(this.customer));
  },
  filters: {}
};
</script>
